import React from 'react';
import Card from '../Card';
import ClientBlock from '../ClientBlock';
import { useRoomInfoQuery } from '../../../../api/roomInfo';
import FetchDataWrapper from '../../../../../../components/FetchDataWrapper';

const ClientsCard = ({ room }) => {
  return (
    <Card>
      <Card.Header title="Собственники/Жители" />
      <FetchWrapper addressId={room?.id}>
        <Body addressId={room?.id} />
      </FetchWrapper>
    </Card>
  );
};

export default ClientsCard;

function Body({ addressId }) {
  const { data } = useRoomInfoQuery({
    params: { addressId },
    options: { select: selectClients },
  });

  return (
    <Card.Body>
      {data?.map((client) => (
        <ClientBlock key={client.id} client={client} />
      ))}
    </Card.Body>
  );
}

function FetchWrapper({ addressId, children }) {
  const { data, isFetching, refetch } = useRoomInfoQuery({
    params: { addressId },
    options: { select: selectFetchDataWrapper },
  });

  return (
    <FetchDataWrapper
      data={data}
      isFetching={isFetching}
      refetch={refetch}
      errMsg="Не удалось загрузить информацию о собственниках/жителях"
    >
      {children}
    </FetchDataWrapper>
  );
}

function selectClients(data) {
  return data?.clients;
}
function selectFetchDataWrapper(data) {
  return data === 'Error' ? data : data?.clients;
}
